export default "__VITE_ASSET__CZthiqn4__"